import script from "./InformacoesAcaoView.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacoesAcaoView.vue?vue&type=script&setup=true&lang=js"

import "./InformacoesAcaoView.vue?vue&type=style&index=0&id=4ee18309&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee18309"]])

export default __exports__